import { useState, useCallback } from "react";

const STORAGE_KEY = "hourglass:updates:last-seen";
// Bump this string whenever new updates are published
const LATEST_UPDATE_ID = "2026-04-02";

export function useNewUpdates() {
  const [hasNew, setHasNew] = useState(
    () => localStorage.getItem(STORAGE_KEY) !== LATEST_UPDATE_ID,
  );

  const markSeen = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, LATEST_UPDATE_ID);
    setHasNew(false);
  }, []);

  return { hasNew, markSeen };
}
